import { render } from "./FlexBoxDemo.vue?vue&type=template&id=08edadde&scoped=true"
const script = {}

import "./FlexBoxDemo.vue?vue&type=style&index=0&id=08edadde&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08edadde"]])

export default __exports__